import '@babel/polyfill';
import Vue from 'vue';
import Element from 'element-ui';
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
import VueClipboard from 'vue-clipboard2';
import AxiosPlugin from './plugins/axios';
import SysPlugin from './plugins/sys';
import App from './app.vue';
import router from './router';
import store from './store';
import './plugins/lodash';
import './styles/app.scss';
import directives from './directives/index';
import Base64 from './assets/base64.js' 
Vue.prototype.$Base64 = Base64;

VueClipboard.config.autoSetContainer = true;
Vue.config.productionTip = false;

Vue.use(Element, { size: 'small' });
Vue.use(SysPlugin);
Vue.use(AxiosPlugin);
Vue.use(VueClipboard);
Vue.use(mavonEditor);
Vue.use(directives);

// 登录控制
router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && !store.state.Auth.token
  && from.path !== '/download/list' && to.path !== '/download/list'
  && to.path !== '/dci/publish'&& to.path !== '/ipc/publish'
  && to.path !== '/publishDciViewSoftware'&& to.path !== '/publishDciViewDetail'
  && to.path !== '/publishDciViewPublishDetail') {//发布页绕开验证
    next('/login');
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
